// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import {perr} from 'hola_pub_util';
import Icon_github from '../../img/icons/github.svg';
import Icon_so from '../../img/icons/stack_overflow.svg';
import Icon_reddit from '../../img/icons/reddit.svg';
import Icon_dev from '../../img/icons/dev.svg';
import Icon_discord from '../../img/icons/discord.svg';
import Svg_bg_left from '../../img/homepage/hero_left.svg';
import Svg_bg_right from '../../img/homepage/hero_right.svg';
import {Button} from '../../lib/button';
import {Uptime} from './uptime';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {Trustpilot_widget} from '../content/trustpilot_widget';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';

import styles from './hero.module.less';
import anim_styles from '../../../../toolip/pub/ui/animation.module.less';

export const Satisfied_users = ({cls}: {cls?: string})=>{
    const icon_cls = cn(styles.icon, cls);
    return <>
      {Array.from({length: 5}).map((_, i)=>{
        const icon = `icon_avatar${i + 1}`;
        return <div key={icon} className={icon_cls}>
          <img alt='avatar' src={oculus_img_url(`icons/${icon}.webp`)}/>
        </div>;
      })}
    </>;
};

export const Hero = ()=>{
    const {theme} = useContext(Settings_context);
    const {show_free_zone_promo} = use_app_context();
    const cta_text = show_free_zone_promo ? 'Try now for free' : 'Try now';
    return <div className={styles.hero_wrapper}>
      <div className={styles.hero}>
        <div className={styles.hero_bg}>
          <Svg_bg_left className={styles.bg_left}/>
          <Svg_bg_right className={styles.bg_right}/>
          <div className={styles.bg_center}/>
        </div>
        <div className={cn(theme.container, styles.container)}>
          <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
            <Uptime/>
          </div>
          <div className={styles.hero_text_wrapper}>
            <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
              Premium Proxies for Just $0.10/GB</h1>
            <div className={cn(styles.hero_cta, anim_styles.hero_showup_3)}>
              <Button caption={<>{cta_text} <Icon_arrow_right/></>}
                size={'l'} to={'/pricing'}
                on_click={()=>{
                  perr({id: 'oculus_homepage_hero_cta_click'});
                }}
              />
            </div>
            {show_free_zone_promo && <p className={cn(theme.p12,
              theme.med, styles.hero_cta_text,
              anim_styles.hero_showup_3)}>
              * No credit card needed. Free plan available.
            </p>}
          </div>
        </div>
      </div>
      <div className={styles.hero_trust}>
        <div><Trustpilot_widget /></div>
        <div className={styles.trust_text}>
          <div className={styles.avatar_wrapper}>
            <Satisfied_users/>
          </div>
          <p className={cn(theme.p14, theme.bold, theme.color_n700)}>
            100,000+ satisfied users</p>
        </div>
      </div>
      <div className={styles.hero_socials}>
        <p className={cn(theme.p14, theme.med, theme.color_n500)}>
          Thousands of developers scrape daily with Oculus proxies:</p>
        <div className={styles.icons}>
          <Icon_github/>
          <Icon_so/>
          <Icon_reddit/>
          <Icon_dev/>
          <Icon_discord/>
        </div>
      </div>
    </div>;
};
